var React = require('react');

function ScrollDownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.203 7.90547H15.3046C15.1968 7.90547 15.0936 7.95234 15.021 8.03437L9.8905 13.9477V0.75C9.8905 0.646875 9.80613 0.5625 9.703 0.5625H8.29675C8.19363 0.5625 8.10925 0.646875 8.10925 0.75V13.9477L2.97878 8.03437C2.90847 7.95234 2.80534 7.90547 2.69519 7.90547H0.796751C0.637376 7.90547 0.550657 8.09531 0.656126 8.21484L8.43503 17.1797C8.50535 17.2608 8.59228 17.3259 8.68994 17.3705C8.78759 17.415 8.89369 17.4381 9.00105 17.4381C9.1084 17.4381 9.2145 17.415 9.31216 17.3705C9.40981 17.3259 9.49675 17.2608 9.56706 17.1797L17.3436 8.21484C17.4491 8.09297 17.3624 7.90547 17.203 7.90547Z","fill":"#808080"}));
}

ScrollDownArrow.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ScrollDownArrow;

ScrollDownArrow.default = ScrollDownArrow;
